import { Button, Padder, Text } from '@oy/ui';
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { DotSteppers } from '../../DotSteppers';
import styles from './MessageContainer.module.css';

type MessageContainerProps = {
  activeIndex: number;
  buttonText: string;
  className?: string;
  message: string;
  onClickButton: () => void;
  steps: number;
  style?: React.CSSProperties;
  title: string;
};

const MessageContainer = forwardRef<HTMLDivElement, MessageContainerProps>(
  (
    {
      activeIndex,
      buttonText,
      className,
      message,
      onClickButton,
      steps,
      style,
      title,
    }: MessageContainerProps,
    ref,
  ) => (
    <div
      className={classNames(styles.container, className)}
      ref={ref}
      style={style}
    >
      <Padder
        bottom={Padder.Size.S}
        className={styles.borderBottom}
        horizontal={Padder.Size.M}
        top={Padder.Size.M}
      >
        <Padder bottom={Padder.Size.XXXS}>
          <Text textStyle={Text.Style.BodyMdSemibold}>{title}</Text>
        </Padder>
        <Padder bottom={Padder.Size.S}>
          <Text textStyle={Text.Style.BodySmRegular}>{message}</Text>
        </Padder>
        {steps > 1 && <DotSteppers activeIndex={activeIndex} steps={steps} />}
      </Padder>
      <Button
        buttonType={Button.Type.Text}
        fullWidth
        onClick={onClickButton}
        size={Button.Size.Large}
      >
        {buttonText}
      </Button>
    </div>
  ),
);

export default MessageContainer;
